export const QUOTE_BLOCK = 'quote-block';
